/* =========================================================================
   SAMSARA — SECTION-PRODUCT-DATA.JS
   Sprint 3 / T3 — Radar SVG reveal IntersectionObserver one-shot.

   Pattern: când section intră în viewport (threshold 0.4), adaugă
   `.is-revealed` pe `.product-data` element → CSS triggers polygon
   scale(0)→scale(1) animation 0.9s cubic-bezier + dots opacity 0→1.

   prefers-reduced-motion: reveal imediat fără animation (CSS handle).

   Vanilla, zero deps. CLAUDE.md JS conventions §3.
   ========================================================================= */

(function () {
  'use strict';

  const sections = document.querySelectorAll('[data-product-data]');
  if (!sections.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || typeof IntersectionObserver === 'undefined') {
    sections.forEach(function (s) { s.classList.add('is-revealed'); });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach(function (s) { observer.observe(s); });
})();
